// v14ad Fase 0 — Pure sort-helpers voor overzichtspagina's.
// Elke module levert eigen `comparators`-map. Deze module exporteert enkel
// een dispatcher `applySort` en een generieke `naturalCompare` helper.

const collator = new Intl.Collator("nl-BE", { sensitivity: "base", numeric: true });

export const naturalCompare = (a, b) => collator.compare(String(a || ""), String(b || ""));

/**
 * Sorteer een lijst op basis van een gekozen sort-key en een comparators-map.
 * Onbekende key → originele volgorde behouden (defensief).
 *
 * @param {Array<any>} items
 * @param {string} sortKey
 * @param {Object<string, (a,b)=>number>} comparators
 * @returns {Array<any>}
 */
export function applySort(items, sortKey, comparators) {
  if (!Array.isArray(items) || !sortKey) return items;
  const cmp = comparators?.[sortKey];
  if (!cmp) return items;
  return [...items].sort(cmp);
}

/**
 * Bouw een orderIndex-gebaseerde comparator (voor business-status-order).
 *
 * @param {(item: any) => string} pickKey
 * @param {string[]} order
 * @param {"asc"|"desc"} direction
 */
export function statusOrderComparator(pickKey, order, direction = "asc") {
  const idx = new Map(order.map((k, i) => [k, i]));
  const sign = direction === "desc" ? -1 : 1;
  return (a, b) => {
    const ai = idx.get(pickKey(a)) ?? 999;
    const bi = idx.get(pickKey(b)) ?? 999;
    return sign * (ai - bi);
  };
}
